import { useEffect, useState } from 'react';

/** Props of both event-days twins. */
export type DefrostScheduleEventDayFieldProps = {
  disabled: boolean;
  error?: string;
  onChange: (values: string[]) => void;
  values: string[];
};

type UseDefrostEventDaysArgs = Omit<DefrostScheduleEventDayFieldProps, 'error'>;

/**
 * State shared by the event-days field's two twins (DefrostScheduleEventDayDropdown
 * and DefrostScheduleEventDayMobileMenu): controlled open, the day toggle, and the
 * trigger's text.
 */
export const useDefrostEventDays = ({ disabled, onChange, values }: UseDefrostEventDaysArgs) => {
  // Still controlled: a disabled trigger will not open, but a menu already open
  // when `disabled` flips has to be closed by us.
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (disabled) setIsOpen(false);
  }, [disabled]);

  const handleOpenChange = (open: boolean) => {
    if (disabled && open) return;
    setIsOpen(open);
  };

  const toggleDay = (checked: boolean, day: string) => {
    const newValues = checked ? [...(values ?? []), day] : (values?.filter((v) => v !== day) ?? []);
    onChange(newValues);
  };

  return {
    handleOpenChange,
    isOpen,
    selectedDays: values?.join(', ') ?? '',
    toggleDay,
  };
};
